import { render } from "./LoginForm.vue?vue&type=template&id=20dcf93d&scoped=true"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"

import "./LoginForm.vue?vue&type=style&index=0&id=20dcf93d&lang=scss&scoped=true"
import "./LoginForm.vue?vue&type=style&index=1&id=20dcf93d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-20dcf93d"

export default script